import { render, staticRenderFns } from "./KurumForm.vue?vue&type=template&id=410b4d3e"
import script from "./KurumForm.vue?vue&type=script&lang=ts"
export * from "./KurumForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports